module.exports = __webpack_public_path__ + "media/images/ring-ring-4b9d9d12edbe0ddb406c150d9fb0dd94.png";